export default __webpack_public_path__ + "static/media/lvrMobile.9ec50404.png";